import { create } from "zustand"
import axiosInstance from "../utils/axiosInstance"

export const useSettingsStore = create((set) => ({
    settings: {
        store_name: '',
        store_address: '',
        store_phone: '',
        store_email: '',
        store_logo: '',
        facebook_url: '',
        twitter_url: '',
        instagram_url: '',
        static_banners: []
    },
    loading: false, 
    fetchSettings: async () => {
        set({loading: true})
        try {
            const response = await axiosInstance.get('/api/settings/store-info')
            console.log('Store Info API response:', response.data)
            set({settings: response.data.data, loading: false})
        } catch (error) {
            console.error('Error fetching settings:', error)
            set({ loading: false })
        }
    }
}))